import { PREPREG } from '../constants/globals';
import { isOuterCopper } from './material';

export const calcThickness = resins => (
  resins.reduce(
    (acc, cur) => (
      acc + cur.count * cur.material.thickness
    ),
    0
  )
);

export const calcGlassThickness = resins => (
  resins.reduce(
    (acc, cur) => (
      acc + cur.count * prepregGlassThickness(cur.material.construction)
    ),
    0
  )
);

const prepregGlassThickness = construction => (
  construction ? construction.reduce(
    (acc, cur) =>  acc + cur.layers * cur.glassThickness,
    0
  ) : 0
);

export const calcPressedThickness = (
  prepreg,
  index = prepreg.index,
  layers = prepreg.getLayers(),
  upperCopper,
  lowerCopper
)=> { 
  const thickness = prepreg.thickness || prepreg._thickness;
  if (prepreg.type !== PREPREG) {
    return thickness;
  }

  const copperUp = upperCopper || layers[index - 1];
  const copperDown = lowerCopper || layers[index + 1];

  const fillRatioUp =
    copperUp && copperUp.fillRatio && !isOuterCopper(copperUp, layers)
    ? copperUp.fillRatio()
    : 0; 
  const fillRatioDown =
    copperDown && copperDown.fillRatio && !isOuterCopper(copperDown, layers)
    ? copperDown.fillRatio()
    : 0;

  const plyCount = prepreg._material.reduce((acc, cur) => acc + cur.count, 0);
  const pressFactor = fillRatioUp === 0 && fillRatioDown === 0 
    ? 1
    : plyCount <= 1
      ? 1.01 
      : plyCount === 2 
        ? 1
        : 0.98
  
  return (thickness - fillRatioUp - fillRatioDown) * pressFactor;
 };

export const calcColor = resins => resins[0].material.color;

export const isThicknessTooThin = (originalThickness, pressedThickness, glassThickness) => {
  const buttercoatThickness = originalThickness - glassThickness;
  const remainingButtercoat = pressedThickness - glassThickness;

  return !isGlassStop(pressedThickness, glassThickness) &&
    remainingButtercoat < buttercoatThickness * 0.1;
}

export const isGlassStop = (pressedThickness, glassThickness) => (
  pressedThickness < glassThickness
)

export const validate = (layer, defaultResinId) => {
  const warnings = [];
  const errors = [];

  const { thickness, glassThickness, pressedThickness } = layer;

  const prepregThicknessWarning = isThicknessTooThin(thickness, pressedThickness, glassThickness);
  const glassStopWarning = isGlassStop(pressedThickness, glassThickness);
  const isHybrid = layer !== undefined  && layer.resinId !== defaultResinId;

  if (prepregThicknessWarning) {
    warnings.push(`
      The current configuration will make this layer of prepreg too thin
    `);
  }

  if (glassStopWarning) {
    warnings.push(`
      The current configuration will make this layer of prepreg fail to adhere to adjacent copper layers
    `);
  }

  if (isHybrid) {
    warnings.push(`
      Hybrid configuration is not recommended
    `);
  }

  return { warnings, errors };
}


// WEBPACK FOOTER //
// ./src/lib/prepreg.js